import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { commonService } from 'src/app/services/common.service';
import { eplService } from 'src/app/services/epl.service';

@Component({
  selector: 'app-obselute-items-popup',
  templateUrl: './obselute-items-popup.component.html',
  styleUrl: './obselute-items-popup.component.scss'
})
export class ObseluteItemsPopupComponent {
  faclose = EMDMICONS.FACLOSE;
  deleteTextBox = ""
  deleteTextboxValue = 0
  crNo = 0;
  eplObseluteData: any[] = [];
  showObselutePopup = false;
  public selectedIds: Set<number> = new Set<number>();

  @Input() set setCRNo(crNo: number) {
    if (crNo > 0) {
      this.crNo = crNo;
      this.loadObseluteItems();
    }
  }


  constructor(private eplService: eplService, private commonService: commonService) {
  }

  loadObseluteItems() {
    this.eplService.getObseluteGridData(this.crNo).subscribe((data) => {
      if (data?.length > 0) {
        data.forEach((x: any) => {
          x.replacedItem = x.replacedItem?.replaceAll(',', '</br>');
          x.deletedItem = x.deletedItem?.replaceAll(',', '</br>');
        })
        this.eplObseluteData = data;
      }
    }
    );
  }

  undoObselute() {
    let ids: Array<number> = [];
    if (this.selectedIds.size == 0) {
      this.commonService.showNotificationMessage('Please select at least one record.', 'error', 'center', 200, true);

    } else {
      this.selectedIds.forEach((index: any) => {
        ids.push(this.eplObseluteData[index]?.changeItemId ?? 0);
      });
      let reqdata = {
        crId: this.crNo,
        changeitemid: ids.join(',')
      };
      this.eplService.undoObselute(reqdata).subscribe((data) => {
        this.commonService.showNotificationMessage("Undo for " + this.selectedIds.size + " item(s) successful.", "success", "center")
        this.closePopup();
      })
    }
  }

  public OnSelectionChangeEvent(event: SelectionEvent, gridName: string): void {
    if (gridName == 'obseluteGrid')
      this.commonService.onGridSelection(this.selectedIds, event);
  }

  @Output() closeContentPopUp = new EventEmitter<boolean>;

  closePopup() {
    this.closeContentPopUp.emit(false);
  }

  openPopup() {
    this.showObselutePopup = true;
  }

}
